import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { navigate } from 'gatsby';

import media from '../utils/breakpoints';
import Icon from './Icon';
import spinner from './spinner.svg';
import arrowRight from './arrow-right.svg';

const SyledForm = styled.form`
  flex-wrap: wrap;
  display: flex;
  width: 20px;
  ${media.tablet`
    width: calc(100% - 200px);
  `}
  width: 100%;
  input {
    height: 40px;
    flex-grow: 1;
    padding: 0 10px;
    :focus {
      border: solid 1px #CF4A3A;
      outline: thin;
    }
  }
  button {
    display: flex;
    justify-content: center;
    align-items: center;
    background: #F36F5F;
    color: white;
    cursor: pointer;
    outline: inherit;
    height: 40px;
    flex-grow: 0;
    flex-basis: 60px;
    border: solid 1px transparent;
    :active {
      background: #CF4A3A;
    }
    :focus {
      border: solid 1px #CF4A3A;
    }
    &:disabled {
      background: grey;
      cursor: not-allowed;
    }
    svg {
      height: 20px;
    }
  }
  .error {
    width: 100%;
    text-align: left;
    p {
      color: red;
      margin: 0;
      font-size: 1rem;
      padding: 2px;
    }
  }
`;

const process = (res) => {
  if (res.status >= 200 && res.status < 300) return res.json();
  throw new Error('Invalid email');
}

export default class Subscribe extends Component {
  static propTypes = {
    redirect: PropTypes.string,
    focus: PropTypes.bool,
  }

  input = React.createRef();

  state = {
    isLoading: false,
    success: false,
    error: false,
  }
  
  handleSubmit = (e) => {
    e.preventDefault();
    if (this.state.isLoading) return;
    const { redirect } = this.props;
    this.setState({ isLoading: true });
    const email = e.target.email.value;
    fetch('https://healthfarm.co/.netlify/functions/subscription', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email }),
    })
    .then(process)
    .then(() => {
      this.setState({ success: true, error: false, isLoading:false });
      if (redirect) {
        setTimeout(() => navigate(redirect), 3000);
      }
    })
    .catch(() => this.setState({ 
      success: false, 
      error: "Invalid email", 
      isLoading:false 
    }));
  }

  renderError = () => {
    const { error, isLoading } = this.state;
    if (!error || isLoading) return null;
    return (
      <div className="error">
        <p>{error}</p>
      </div>
    );
  }

  render() {
    const { isLoading, success } = this.state;
    const { redirect, focus } = this.props;
    if (focus) {
      this.input.current.focus();
    }
    if (success) return (
      <React.Fragment>
        <span>Check your inbox, you have successfully subscribed!</span>
        { redirect && (
          <React.Fragment>
            <br />
            <span>Redirecting...</span>
          </React.Fragment>
        ) }
      </React.Fragment>
    );
    const icon = isLoading ? spinner : arrowRight;
    return (
      <SyledForm onSubmit={this.handleSubmit}>
        <input ref={this.input} aria-label="Email address" type="email" name="email" placeholder="Email" />
        <button 
          aria-label="subscribe"
          role="presentation" 
          type="submit"
        >
          <Icon spin={isLoading} icon={icon} fill="white" />
        </button>
        {this.renderError()}
      </SyledForm>
    );
  }
}
